import { withAuth } from '..';
import { APIResponse } from '../../../system-libraries/api-types';
import { constructGetUserDetailsApiUrl } from '../../../system-utils/api-utils/endpoints/urls';
import { UserDetailsApiResponseBody } from './types';

export const getUserDetails = (): Promise<APIResponse<UserDetailsApiResponseBody>> =>
  withAuth(({ headers }) =>
    fetch(constructGetUserDetailsApiUrl(), {
      method: 'GET',
      headers,
    }),
  ).then((resp: APIResponse) => {
    if (resp.status !== 200) {
      throw 'Error loading user details';
    }
    return resp;
  });
